<template>
<div class="d-flex" v-bind="$attrs">
    <CLink style="min-width:60px" @click="toggleCollapse" class="btn btn-behance btn-sm">
        <FaIcon icon="filter" /> {{ $t('table.filter') }}
    </CLink>
    <CLink v-if="showClear" @click="clearSearch" class="text-center d-inline-block mx-2 font-xs">
        {{ $t('table.clearing') }}
    </CLink>
    <CFilterSidebar aside class="shadow-lg"  size="lg" :show.sync="collapse">
        <div class="c-sidebar-brand position-relative bg-white b-b-1 mb-3">
            <CLink @click="toggleCollapse" class="position-absolute" style="left:10px;">
                <FaIcon icon="times" class="text-dark" />
            </CLink>
            <span class="h6 mb-0 text-dark">{{ $t('table.type_string') }}</span>
        </div>

        <div class="c-sidebar-nav mx-2" v-if="Object.keys(filterMeFields).length > 0" ref="filterElements">
            <slot name="form" v-bind:filters="filterMeFields" v-bind:search="search"></slot>
        </div>

        <div class="position-absolute w-100 bg-white b-t-1" style="bottom:0;z-index:100;">
            <CButton @click="search" color="behance" class="square d-inline-block w-50 btn-lg">
                {{ $t('table.filter') }}
            </CButton>
            <CButton @click="clearSearch" class="square d-inline-block w-50 btn-lg">
                {{ $t('table.clearing') }}
            </CButton>
        </div>
    </CFilterSidebar>
</div>
</template>

<script>
import {
    mapGetters, mapActions
} from 'vuex'

export default {
    name: 'FilterMe',

    data() {
        return {
            localFilters: {},
            showClear: this.initShowClear,
        }
    },

    props: {
        filters: {
            required: true,
            type: Object,
        },
        initShowClear: {
            default: false
        },
        focusOn: {
            default: true,
            type: Boolean,
        }
    },

    computed: {
        ...mapGetters('filterMeComponent', [
            'filterMeFields'
        ]),
        collapse: {
            get() {
                return this.$store.getters['filterMeComponent/collapse']
            },
            set(val) {
                if (val === 'responsive') {
                    this.hideCollapse()
                }
            }
        }
    },

    watch: {
        collapse(val, oldVal) {
            // When route params changed but router view not changed `filterMeFields` variable reinitiate again.
            if (Object.keys(this.filterMeFields).length === 0) {
                this.initiateState()
            }

            const backdrop = document.getElementsByClassName('c-filter-sidebar-backdrop')[0]
            const input = this.$refs.filterElements ? this.$refs.filterElements.querySelector('.form-group input') : false
            if (val === true) {
                this.focusOn && input && input.focus()
                backdrop.className = 'c-filter-sidebar-backdrop c-show'
            } else if (oldVal === true) {
                backdrop.className = 'c-filter-sidebar-backdrop d-none'
            }
        }
    },
    methods: {
        ...mapActions('filterMeComponent', [
            'setFilterMe', 'toggleCollapse', 'hideCollapse'
        ]),
        search() {
            this.showClear = JSON.stringify(this.filterMeFields) !== JSON.stringify(this.localFilters)
            if (this.$isMobile()) {
                this.toggleCollapse()
            }

            this.$emit('onSubmit', this.filterMeFields)
        },
        clearSearch() {
            this.showClear = false

            this.setFilterMe(this.localFilters)

            this.$emit('onClear')
            this.$emit('onSubmit', this.filterMeFields)
        },
        initiateState() {
            this.localFilters = JSON.parse(JSON.stringify(this.filters))
            this.setFilterMe(this.filters)
        }
    },

    created() {
        this.initiateState()
    },
}
</script>


<style lang="scss" scoped>
.c-sidebar {
    color: #636f83 !important;
    background-color: #fff!important;
    width: 300px;

}

.c-sidebar.c-sidebar-fixed {
    z-index: 999999999999;
}

*[dir="rtl"] .c-sidebar.c-sidebar-right {
    margin-left: -300px;
}
*[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0;
}

@media screen and (max-width: 425px) {
    .c-sidebar {
        width: 100%;
    }
    *[dir="rtl"] .c-sidebar.c-sidebar-right {
        margin-left: -100%;
    }
    *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right {
        margin-left: 0;
    }
}
.c-sidebar-nav .row{
    padding: 0;
    margin: 0;
}
</style>